import { InjectionToken } from "@angular/core";

/**
 * Defines the injection token of the clinic one API base url.
 */
export const CLINIC_ONE_API_BASE_URL = new InjectionToken<string>(
  "ClinicOneApiBaseUrl"
);

/**
 * Defines the injection token of the clinic one API version used.
 */
export const CLINIC_ONE_API_VER = new InjectionToken<string>(
  "ClinicOneApiVersion"
);

/**
 * Feature flag to enable direct-to-S3 uploads.
 */
export const CLINIC_ONE_DIRECT_S3_UPLOAD_ENABLED = new InjectionToken<boolean>(
  "ClinicOneDirectS3UploadEnabled"
);
